import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-login-forgot-password-email',
  templateUrl: './forgot-password-email.component.html',
  styleUrls: ['../login.component.css', './forgot-password-email.component.css'],
  standalone: false,
})
export class ForgotPasswordEmailComponent {
  // Context bridge to parent login component
  @Input() ctx: any;
  @Input() loading = false;

  constructor(public theme: ThemeService) {}
}
